import React, { Component } from "react";
import {
    Input,
    Segment,
    Form,
    Checkbox,
    TextArea,
    Button,
    Select,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import styles from "./show.module.scss";
import Header from "../../assets/components/header";
import Footer from "../../assets/components/footer";
import Partial404 from "../errors/partials/404";
import Partial500 from "../errors/partials/500";

import NotificationActions from "../../store/actions/notification";
import ValidationActions from "../../store/actions/validation";
import AppVariable from "../../models/AppVariable";
import CenterLoader from "../../assets/components/CenterLoader";

class AppVariablesShow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            loadingAppVariable: true,
            error: null,
            notification: null,
            appVariable: new AppVariable(),
            // new
            dataJsonError: null,
            dataLinks: [],
            linkListErrors: {},
        };

        if (this.props.user.has("MASHIE_ADMIN") === false) {
            this.props.history.push("/members");
        }
    }

    componentDidMount() {
        this.getAppVariable();
    }

    componentWillUnmount() {
        this.props.dispatch(NotificationActions.remove());
    }

    errorsFor(field) {
        if (this.props.validation !== null) {
            if (typeof this.props.validation[field] !== "undefined") {
                return (
                    <span className='has-error'>
                        {" "}
                        {this.props.validation[field][0]}{" "}
                    </span>
                );
            }
        }
    }

    displayError() {
        if (this.state.error === 500) {
            return <Partial500 />;
        }

        if (this.state.error === 404) {
            return <Partial404 />;
        }
    }

    notification(type, text) {
        this.props.dispatch(NotificationActions.create({ type, text }));
    }

    handleValidationErrors(error) {
        if (error.response.status === 422) {
            this.props.dispatch(
                ValidationActions.create(error.response.data.errors),
            );
        }
    }

    handleNewAdminValidationErrors(error) {
        if (error.response.status === 422) {
            this.setState({
                validationErrorsNewAdmin: error.response.data.errors,
            });
        }
    }

    getAppVariable() {
        const { id } = this.props.match.params;
        AppVariable.getByIdOrKey(id)
            .then((data) => {
                const appVariable = new AppVariable(data);

                const type = appVariable.type || "text";
                const links =
                    type === "linkList"
                        ? this.normaliseLinkList(appVariable.data)
                        : [];

                const linkValidation = this.validateLinkList(links);

                this.setState({
                    loadingAppVariable: false,
                    appVariable,
                    dataLinks: links,
                    dataJsonError: null,
                    linkListErrors: linkValidation.errorsByIndex,
                });
            })
            .catch((error) => {
                this.setState({ error: error.response.status });
                this.notification(
                    "error",
                    "Failed to load app variable, please try again",
                );
            });
    }

    safeParseJsonString(value) {
        if (typeof value !== "string")
            return { ok: true, value: value ?? null };
        const trimmed = value.trim();
        if (trimmed.length === 0) return { ok: true, value: null };

        try {
            return { ok: true, value: JSON.parse(trimmed) };
        } catch (e) {
            return { ok: false, error: e?.message || "Invalid JSON" };
        }
    }

    stringifyJson(value) {
        // Keep it compact if null/undefined; otherwise pretty-print
        if (value === null || typeof value === "undefined") return "";
        return JSON.stringify(value, null, 2);
    }

    normaliseLinkList(value) {
        // value can be: null, [], stringified array, or something unexpected
        const parsed =
            typeof value === "string"
                ? this.safeParseJsonString(value)
                : { ok: true, value };

        if (!parsed.ok) return [];

        if (!Array.isArray(parsed.value)) return [];

        return parsed.value
            .filter((x) => x && typeof x === "object")
            .map((x) => ({
                text: typeof x.text === "string" ? x.text : "",
                body: typeof x.body === "string" ? x.body : "",
                link: typeof x.link === "string" ? x.link : "",
            }));
    }

    syncLinkListToData(links) {
        const { appVariable } = this.state;
        appVariable.data = JSON.stringify(links);

        const validation = this.validateLinkList(links);

        this.setState({
            appVariable,
            dataLinks: links,
            linkListErrors: validation.errorsByIndex,
        });
    }

    onChangeName(event) {
        const appVariable = this.state.appVariable;
        appVariable[event.target.name] = event.target.value;
        this.setState({ appVariable });
    }

    onChangeValue(event) {
        const { appVariable } = this.state;
        appVariable[event.target.name] = event.target.value;
        this.setState({ appVariable });
    }

    onChangeData(event) {
        const { appVariable } = this.state;
        const value = event.target.value;

        appVariable[event.target.name] = value;

        if ((appVariable.type || "text") === "json") {
            const parsed = this.safeParseJsonString(value);
            this.setState({
                appVariable,
                dataJsonError: parsed.ok ? null : parsed.error,
            });
            return;
        }

        this.setState({ appVariable });
    }

    onBlurDataJson() {
        const { appVariable } = this.state;
        if ((appVariable.type || "text") !== "json") return;

        const parsed = this.safeParseJsonString(appVariable.data || "");
        if (!parsed.ok) return;

        appVariable.data = this.stringifyJson(parsed.value);
        this.setState({ appVariable });
    }

    onChangeToggleIsEnabled() {
        const { appVariable } = this.state;
        appVariable.isEnabled = !appVariable.isEnabled;
        this.setState({ appVariable });
    }

    onChangeType(event, data) {
        const { appVariable } = this.state;
        const nextType = data.value;

        appVariable.type = nextType;

        // If switching to linkList, ensure data is a valid array JSON string
        if (nextType === "linkList") {
            const links = this.normaliseLinkList(appVariable.data);
            appVariable.data = JSON.stringify(links);

            const linkValidation = this.validateLinkList(links);

            this.setState({
                appVariable,
                dataLinks: links,
                dataJsonError: null,
                linkListErrors: linkValidation.errorsByIndex,
            });
            return;
        }

        // If switching to json, try to validate existing string
        if (nextType === "json") {
            const parsed = this.safeParseJsonString(appVariable.data || "");
            this.setState({
                appVariable,
                dataJsonError: parsed.ok ? null : parsed.error,
            });
            return;
        }

        // text: no special handling
        this.setState({ appVariable, dataJsonError: null });
    }

    addLinkItem() {
        const links = [...(this.state.dataLinks || [])];
        links.push({ text: "", body: "", link: "" });
        this.syncLinkListToData(links);
    }

    removeLinkItem(index) {
        const links = [...(this.state.dataLinks || [])];
        links.splice(index, 1);
        this.syncLinkListToData(links);
    }

    moveLinkItem(index, direction) {
        const links = [...(this.state.dataLinks || [])];
        const nextIndex = index + direction;
        if (nextIndex < 0 || nextIndex >= links.length) return;

        const tmp = links[index];
        links[index] = links[nextIndex];
        links[nextIndex] = tmp;

        this.syncLinkListToData(links);
    }

    updateLinkItem(index, field, value) {
        const links = [...(this.state.dataLinks || [])];
        links[index] = { ...links[index], [field]: value };
        this.syncLinkListToData(links);
    }

    isValidHttpsFqdnUrl(raw) {
        if (typeof raw !== "string") return false;

        const value = raw.trim();
        if (value.length === 0) return false;

        let url;
        try {
            url = new URL(value);
        } catch (e) {
            return false;
        }

        // Must be https
        if (url.protocol !== "https:") return false;

        // Must have a hostname
        const host = url.hostname;
        if (!host) return false;

        // Reject localhost
        if (host.toLowerCase() === "localhost") return false;

        // Reject IPv4
        const ipv4 = /^(?:\d{1,3}\.){3}\d{1,3}$/;
        if (ipv4.test(host)) return false;

        // Reject IPv6 literals
        if (host.includes(":")) return false;

        // Must be FQDN-ish: at least one dot and TLD length >= 2
        // Also ensure no empty labels, no leading/trailing hyphen labels, and valid chars
        const fqdn =
            /^(?=.{1,253}$)(?!-)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;

        if (!fqdn.test(host)) return false;

        return true;
    }

    validateLinkList(links) {
        // returns { ok: boolean, errorsByIndex: { [i]: string[] } }
        const errorsByIndex = {};

        (links || []).forEach((item, i) => {
            const errs = [];

            const text = (item?.text || "").trim();
            const body = (item?.body || "").trim();
            const link = (item?.link || "").trim();

            // Optional: enforce text too (you didn’t require it, but good UX)
            // If you want text required, uncomment:
            // if (!text) errs.push("Text is required");

            if (!link) {
                errs.push("Link is required");
            } else if (!this.isValidHttpsFqdnUrl(link)) {
                errs.push(
                    "Link must be a valid https URL with an FQDN host (e.g. https://example.com/path)",
                );
            }

            if (errs.length) errorsByIndex[i] = errs;
        });

        return { ok: Object.keys(errorsByIndex).length === 0, errorsByIndex };
    }

    save() {
        const type = this.state.appVariable.type || "text";

        // Block invalid JSON
        if (type === "json" && this.state.dataJsonError) {
            this.notification("error", "Data is not valid JSON");
            return;
        }

        // Block invalid links
        if (type === "linkList") {
            const validation = this.validateLinkList(
                this.state.dataLinks || [],
            );
            if (!validation.ok) {
                this.setState({ linkListErrors: validation.errorsByIndex });
                this.notification(
                    "error",
                    "Please fix invalid links before saving",
                );
                return;
            }
        }

        this.setState({ saving: true });
        this.state.appVariable
            .update()
            .then((response) => {
                this.setState({
                    saving: false,
                    appVariable: new AppVariable(response.data.data),
                });
                this.notification("success", "App variable saved");
            })
            .catch((error) => {
                this.setState({ saving: false });
                this.notification("error", "Failed to save app variable");
                this.handleValidationErrors(error);
            });
    }

    loaded() {
        return this.state.loadingAppVariable === false;
    }

    offerDetailsTab() {
        const type = this.state.appVariable.type || "text";
        const linkListInvalid =
            type === "linkList" &&
            Object.keys(this.state.linkListErrors || {}).length > 0;

        const jsonInvalid = type === "json" && !!this.state.dataJsonError;

        const saveDisabled =
            this.state.saving || linkListInvalid || jsonInvalid;

        return (
            <div className={styles.mainSegment}>
                <h3>Details</h3>
                <p>Edit the app variables details.</p>
                <Segment vertical>
                    {this.errorsFor("name")}
                    <label className='with-input'>Name</label>
                    <Input
                        fluid
                        name='name'
                        value={this.state.appVariable.name || ""}
                        onChange={this.onChangeName.bind(this)}
                    />
                </Segment>
                <Segment vertical>
                    <label className='with-input'>Enabled</label>
                    <Checkbox
                        toggle
                        checked={this.state.appVariable.isEnabled}
                        onChange={this.onChangeToggleIsEnabled.bind(this)}
                    />
                </Segment>
                <Segment vertical>
                    {this.errorsFor("type")}
                    <label className='with-input'>Data type</label>
                    <Select
                        fluid
                        selection
                        name='type'
                        value={this.state.appVariable.type || "text"}
                        onChange={this.onChangeType.bind(this)}
                        options={[
                            { key: "text", value: "text", text: "Text" },
                            { key: "json", value: "json", text: "JSON" },
                            {
                                key: "linkList",
                                value: "linkList",
                                text: "Link list",
                            },
                        ]}
                    />
                </Segment>
                <Segment vertical>
                    {this.errorsFor("val")}
                    <label className='with-input'>Value</label>
                    <Form>
                        <TextArea
                            name='val'
                            value={this.state.appVariable.val || ""}
                            onChange={this.onChangeValue.bind(this)}
                        />
                    </Form>
                </Segment>
                <Segment vertical>
                    {this.errorsFor("data")}
                    <label className='with-input'>Data</label>

                    {(() => {
                        const type = this.state.appVariable.type || "text";

                        // TEXT (unchanged)
                        if (type === "text") {
                            return (
                                <Form>
                                    <TextArea
                                        name='data'
                                        value={
                                            this.state.appVariable.data || ""
                                        }
                                        onChange={this.onChangeData.bind(this)}
                                    />
                                </Form>
                            );
                        }

                        // JSON
                        if (type === "json") {
                            return (
                                <>
                                    {this.state.dataJsonError && (
                                        <div
                                            className='has-error'
                                            style={{ marginBottom: 10 }}
                                        >
                                            Invalid JSON:{" "}
                                            {this.state.dataJsonError}
                                        </div>
                                    )}

                                    <Form>
                                        <TextArea
                                            name='data'
                                            value={
                                                this.state.appVariable.data ||
                                                ""
                                            }
                                            onChange={this.onChangeData.bind(
                                                this,
                                            )}
                                            onBlur={this.onBlurDataJson.bind(
                                                this,
                                            )}
                                            placeholder='Enter valid JSON here...'
                                        />
                                    </Form>

                                    <div style={{ marginTop: 8, opacity: 0.8 }}>
                                        Saved value will be stored as a JSON
                                        string.
                                    </div>
                                </>
                            );
                        }

                        // LINK LIST
                        if (type === "linkList") {
                            const links = this.state.dataLinks || [];

                            return (
                                <>
                                    <div style={{ marginBottom: 10 }}>
                                        <Button
                                            type='button'
                                            className='theme'
                                            primary
                                            onClick={this.addLinkItem.bind(
                                                this,
                                            )}
                                        >
                                            Add link
                                        </Button>
                                    </div>

                                    {links.length === 0 ? (
                                        <div style={{ opacity: 0.8 }}>
                                            No links yet. Click “Add link”.
                                        </div>
                                    ) : (
                                        <div>
                                            {links.map((item, i) => {
                                                const rowErrors =
                                                    this.state.linkListErrors?.[
                                                        i
                                                    ] || [];
                                                return (
                                                    <Segment key={i}>
                                                        <div
                                                            className='d-flex'
                                                            style={{
                                                                gap: 10,
                                                                alignItems:
                                                                    "center",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    flex: 1,
                                                                }}
                                                            >
                                                                <label className='with-input'>
                                                                    Text
                                                                </label>
                                                                <Input
                                                                    fluid
                                                                    value={
                                                                        item.text
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.updateLinkItem(
                                                                            i,
                                                                            "text",
                                                                            e
                                                                                .target
                                                                                .value,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    flex: 1,
                                                                }}
                                                            >
                                                                <label className='with-input'>
                                                                    Body
                                                                    (optional)
                                                                </label>
                                                                <Input
                                                                    fluid
                                                                    value={
                                                                        item.body
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.updateLinkItem(
                                                                            i,
                                                                            "body",
                                                                            e
                                                                                .target
                                                                                .value,
                                                                        )
                                                                    }
                                                                />
                                                            </div>

                                                            <div
                                                                style={{
                                                                    flex: 2,
                                                                }}
                                                            >
                                                                <label className='with-input'>
                                                                    Link
                                                                </label>
                                                                <Input
                                                                    fluid
                                                                    value={
                                                                        item.link
                                                                    }
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        this.updateLinkItem(
                                                                            i,
                                                                            "link",
                                                                            e
                                                                                .target
                                                                                .value,
                                                                        )
                                                                    }
                                                                    placeholder='https://example.com/...'
                                                                />
                                                                {rowErrors.length >
                                                                    0 && (
                                                                    <div
                                                                        className='has-error'
                                                                        style={{
                                                                            marginTop: 6,
                                                                        }}
                                                                    >
                                                                        {rowErrors.map(
                                                                            (
                                                                                msg,
                                                                                idx,
                                                                            ) => (
                                                                                <div
                                                                                    key={
                                                                                        idx
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        msg
                                                                                    }
                                                                                </div>
                                                                            ),
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                    flexDirection:
                                                                        "column",
                                                                    gap: 6,
                                                                }}
                                                            >
                                                                <Button
                                                                    type='button'
                                                                    size='small'
                                                                    onClick={() =>
                                                                        this.moveLinkItem(
                                                                            i,
                                                                            -1,
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        i === 0
                                                                    }
                                                                >
                                                                    ↑
                                                                </Button>
                                                                <Button
                                                                    type='button'
                                                                    size='small'
                                                                    onClick={() =>
                                                                        this.moveLinkItem(
                                                                            i,
                                                                            +1,
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        i ===
                                                                        links.length -
                                                                            1
                                                                    }
                                                                >
                                                                    ↓
                                                                </Button>
                                                            </div>

                                                            <div>
                                                                <Button
                                                                    type='button'
                                                                    size='small'
                                                                    negative
                                                                    onClick={() =>
                                                                        this.removeLinkItem(
                                                                            i,
                                                                        )
                                                                    }
                                                                >
                                                                    Remove
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </Segment>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {/* IMPORTANT: appVariable.data is still being set as a JSON string behind the scenes */}
                                </>
                            );
                        }

                        // fallback
                        return null;
                    })()}
                </Segment>
                <Segment vertical>
                    <Button
                        size='large'
                        floated='right'
                        className='theme'
                        primary
                        onClick={this.save.bind(this)}
                        disabled={saveDisabled}
                        loading={this.state.saving}
                    >
                        Save
                    </Button>
                </Segment>
            </div>
        );
    }

    body() {
        if (this.state.error) {
            return this.displayError();
        }

        if (this.loaded() === false) {
            return <CenterLoader />;
        }

        return (
            <div className='container'>
                <div className='row skinny'>
                    <div className='col'>
                        <Tabs
                            defaultActiveKey='details'
                            id='uncontrolled-tab-example'
                        >
                            <Tab eventKey='details' title='Details'>
                                {this.offerDetailsTab()}
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />

                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        notification: state.notification,
        validation: state.validation,
    };
}

export default connect(mapStateToProps)(AppVariablesShow);
